import React from "react";
import { motion } from "framer-motion";
import { ChevronLeft, LayoutList } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BackToOffersButton = ({ className = "" }) => {
  const navigate = useNavigate();

  return (
    <motion.button
      type="button"
      whileHover={{ scale: 1.02, x: -2 }}
      whileTap={{ scale: 0.98 }}
      onClick={() => navigate("/offers")}
      className={`group inline-flex items-center gap-3 pl-2 pr-4 py-2 rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-200 hover:border-[#FF6C6C]/35 hover:bg-gradient-to-r hover:from-[#FF6C6C]/5 hover:to-white hover:shadow-md ${className}`}
      aria-label="Back to offers"
    >
      <span className="flex justify-center items-center w-10 h-10 rounded-xl bg-gray-50 border border-gray-100 transition-colors duration-200 group-hover:bg-[#FF6C6C]/10 group-hover:border-[#FF6C6C]/20">
        <LayoutList className="w-[18px] h-[18px] text-gray-600 transition-colors duration-200 group-hover:text-[#FF6C6C]" />
      </span>
      <span className="text-left min-w-0">
        <span className="block text-[11px] font-medium tracking-wide text-gray-500 uppercase leading-none">
          Return to
        </span>
        <span className="block mt-1 text-sm font-semibold text-gray-900 transition-colors duration-200 group-hover:text-[#FF6C6C]">
          All Offers
        </span>
      </span>
      <ChevronLeft className="w-4 h-4 text-gray-400 transition-all duration-200 group-hover:text-[#FF6C6C] group-hover:-translate-x-0.5 shrink-0" />
    </motion.button>
  );
};

export default BackToOffersButton;
